/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProductDtoCreate } from '../../models/product-dto-create';
import { ProductItem } from '../../models/product-item';

export interface ProductControllerUpdate$Params {
  id: number;
      body: ProductDtoCreate
}

export function productControllerUpdate(http: HttpClient, rootUrl: string, params: ProductControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>> {
  const rb = new RequestBuilder(rootUrl, productControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProductItem;
      }>;
    })
  );
}

productControllerUpdate.PATH = '/product/{id}';
